import { useCreateReferenceImage } from 'hooks/queries/schedules/contents/useCreateReferenceImage'
import { useReferenceImageSync } from 'hooks/queries/schedules/contents/useReferenceImage'
import { ReferenceImgLoading, ReferenceImg } from 'screens/Schedule/PostPromptsSection/ReferenceImg'
import { BrandPlanScheduleContent } from 'types'

interface Props {
  scheduleId: number
  width: number
  height: number
  alt: string
  content: BrandPlanScheduleContent
}

export const LazyCreateReferenceImage = ({ scheduleId, content, width, height, alt }: Props) => {
  const { mutate: createReferenceImage } = useCreateReferenceImage()
  const { data: referenceImage } = useReferenceImageSync(
    { scheduleId, contentId: content.id },
    {
      onSuccess: (data) => {
        if (!data.media_file && !data.status) {
          createReferenceImage({ scheduleId, contentId: content.id })
        }
      },
    },
  )

  if (!referenceImage || ['pending', 'processing'].includes(referenceImage?.status || '')) {
    return <ReferenceImgLoading topicGenerated={!!content?.topic} />
  }

  return (
    <ReferenceImg
      width={width}
      height={height}
      src={referenceImage.media_file?.source_url || ''}
      alt={alt}
      topicGenerated={!!content?.topic}
    />
  )
}
